import * as types from './actionTypes'
// @ts-ignore
import { createRequestActions } from 'helpers'

export const notificationsScroll = ({ scrollTop, clientHeight, scrollHeight }: { [key: string]: number }) => ({
  type: types.NOTIFICATIONS_SCROLL,
  payload: {
    scrollTop,
    clientHeight,
    scrollHeight,
  },
})

export const notifications = {
  get: createRequestActions({
    request: types.NOTIFICATIONS.GET.REQUEST,
    success: types.NOTIFICATIONS.GET.SUCCESS,
    fail: types.NOTIFICATIONS.GET.FAIL,
  }),
}

export const notificationsLoadMore = {
  get: createRequestActions({
    request: types.NOTIFICATIONS_LOAD_MORE.GET.REQUEST,
    success: types.NOTIFICATIONS_LOAD_MORE.GET.SUCCESS,
    fail: types.NOTIFICATIONS_LOAD_MORE.GET.FAIL,
  }),
}

export const notificationsUnreadCount = {
  get: createRequestActions({
    request: types.NOTIFICATIONS_UNREAD_COUNT.GET.REQUEST,
    success: types.NOTIFICATIONS_UNREAD_COUNT.GET.SUCCESS,
    fail: types.NOTIFICATIONS_UNREAD_COUNT.GET.FAIL,
  }),
}

export const notificationsMarkedRead = {
  get: createRequestActions({
    request: types.NOTIFICATIONS_MARKED_READ.GET.REQUEST,
    success: types.NOTIFICATIONS_MARKED_READ.GET.SUCCESS,
    fail: types.NOTIFICATIONS_MARKED_READ.GET.FAIL,
  }),
}

export const enableNotificationsLoadMorePending = {
  type: types.NOTIFICATIONS_ENABLE_LOAD_MORE_PENDING,
}

export const enableNotificationsGetPending = {
  type: types.NOTIFICATIONS_ENABLE_GET_PENDING,
}

export const reactionCreated = (payload: any) => ({
  type: types.REACTION_CREATED,
  payload,
})

export const reactionUpdated = (payload: any) => ({
  type: types.REACTION_UPDATED,
  payload,
})

export const mentionCreated = (payload: any) => ({
  type: types.MENTION_CREATED,
  payload,
})

export const peerInviteAccepted = (payload: any) => ({
  type: types.PEER_INVITE_ACCEPTED,
  payload,
})
